import React, { FC } from 'react'
import { SVGProps } from './types'

export const Trash: FC<SVGProps> = ({ size, onClick, color }) => {
  return (
    <svg
      viewBox=" 0 0 24 24"
      fill="none"
      width={size}
      height={size}
      onClick={onClick}
    >
      <path
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1"
        stroke={color}
        fill="none"
        d="M16.13 22H7.87C7.37 22 6.95 21.63 6.88 21.14L5 8H19L17.12 21.14C17.05 21.63 16.63 22 16.13 22Z"
      />
      <path
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1"
        stroke={color}
        d="M3.5 8H20.5"
      />
      <path
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1"
        stroke={color}
        d="M10 12V18"
      />
      <path
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1"
        stroke={color}
        d="M14 12V18"
      />
      <path
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1"
        stroke={color}
        fill="none"
        d="M16 5H8L9.7 2.45C9.89 2.17 10.2 2 10.54 2H13.47C13.8 2 14.12 2.17 14.3 2.45L16 5Z"
      />
      <path
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1"
        stroke={color}
        d="M3 5H21"
      />
    </svg>
  )
}
